import { memo, useRef, useState } from "react";
import { useTranslate } from "helpers";
import { Modal } from "ui/components/Modal";
import ModalHeader from "ui/components/Modal/ModalHeader";
import ModalBody from "ui/components/Modal/ModalBody";
import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";
import { uploadFiscalizationCertificateAPI } from "services/api/settings/fiscalization/api";
import { CertificateUploadModalProps } from "./types";

const CertificateUploadModal: React.FC<CertificateUploadModalProps> = (props) => {
  const { show, onHide, onSuccess } = props;

  const { t } = useTranslate();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File | null>(null);
  const [password, setPassword] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const handleUpload = async () => {
    if (!file || !password) return;

    setIsLoading(true);
    try {
      const result = await uploadFiscalizationCertificateAPI(file, password);
      onSuccess(result);
      onHide();
    } catch (e) {
      // error handled by API layer
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} position="centered">
      <ModalHeader
        title="Učitaj certifikat"
        icon="/media/images/add-icon.svg"
        onHide={onHide}
      />
      <ModalBody>
        <div className="p-4">
          <div className="mb-3">
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Certifikat (.pfx, .p12)
            </label>
            <input
              ref={fileInputRef}
              type="file"
              accept=".pfx,.p12"
              onChange={handleFileChange}
              className="block w-full text-sm text-slate-500
                file:mr-4 file:py-2 file:px-4
                file:rounded-md file:border-0
                file:text-sm file:font-medium
                file:bg-blue-50 file:text-blue-700
                hover:file:bg-blue-100"
            />
          </div>
          <div className="mb-3">
            <TextField
              type="password"
              name="password"
              label="Lozinka certifikata"
              placeholder="Unesite lozinku certifikata"
              value={password}
              onChange={handlePasswordChange}
              required
            />
          </div>
          <div className="flex justify-end gap-3 pt-3">
            <Button
              variant="outlined"
              children={t("admin.close")}
              onClick={onHide}
            />
            <Button
              variant="primary"
              children="Učitaj"
              onClick={handleUpload}
              disabled={!file || !password || isLoading}
            />
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default memo(CertificateUploadModal);
